import { FC } from "react";
import { GlobeIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnText } from "@/components/VnText/VnText";
import {
  VnTooltip,
  VnTooltipContent,
  VnTooltipTrigger,
} from "@/components/VnTooltip";
import { useAppLanguage } from "@/hooks/useAppLanguage";
import { envVariables } from "@/utils/envVariables";
import { cn } from "@/utils/tailwind";

import { FullLogo } from "./FullLogo";
import { LanguageSelector } from "./LanguageSelector";
import { ThemeToggle } from "./ThemeToggle";

type AppHeaderPropsType = {
  className?: string;
  shouldShowThemeToggle?: boolean;
  shouldShowLanguageSelector?: boolean;
};

export const AppHeader: FC<AppHeaderPropsType> = ({
  className,
  shouldShowThemeToggle = true,
  shouldShowLanguageSelector = true,
}) => {
  const { language } = useAppLanguage();

  const isLocalOrDevEnv =
    envVariables.EXPO_PUBLIC_ENVIRONMENT === "local" ||
    envVariables.EXPO_PUBLIC_ENVIRONMENT === "development";

  return (
    <VnBox
      className={cn(
        "bg-sidebar flex-row items-center justify-between",
        className,
      )}>
      <FullLogo className="text-secondary h-5" />
      {isLocalOrDevEnv && shouldShowThemeToggle && (
        <VnTooltip>
          <VnTooltipTrigger>
            <ThemeToggle />
          </VnTooltipTrigger>
          <VnTooltipContent>
            <VnText i18nKey="native:appHeader.toggleThemeTooltip" />
          </VnTooltipContent>
        </VnTooltip>
      )}

      {shouldShowLanguageSelector && (
        <LanguageSelector>
          <VnButton variant="outline" IconComponent={GlobeIcon}>
            <VnText variant="lgMedium">{language}</VnText>
          </VnButton>
        </LanguageSelector>
      )}
    </VnBox>
  );
};
